import { render, staticRenderFns } from "./InvestmentSteps.vue?vue&type=template&id=20dad6f2&scoped=true&"
import script from "./InvestmentSteps.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InvestmentSteps.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InvestmentSteps.vue?vue&type=style&index=0&id=20dad6f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dad6f2",
  null
  
)

export default component.exports